export default {
  reports: [],
  users: [],
  measuringPoints: [],
  subDistricts: [],
  villages: [],
  userLogs: []
}
